import { InputText } from "primereact/inputtext"
import { CustomDateInput } from "../../CustomDateInput/CustomDateInput"
import { Controller, useForm } from "react-hook-form";
import { GenericInput } from "../../LeasingInfo/components/GenericInput";
import { Calendar } from "primereact/calendar";
import { useEffect } from "react";


export const PersonalData = ({ control, register, defaultVals, errors, setValue, typePerson, watch, trigger }) => {
    // Observar cambios en los campos de email para re-validar
    const emailValue = watch("email");
    const email2Value = watch("email2");

    useEffect(() => {
        if (trigger) {
            trigger("email");
            trigger("email2");
        }
    }, [emailValue, email2Value, trigger]);

    return (
        <div className="InputsDiv">
            <div className={`TextContainer mt-4`}>
                Ingresa los datos personales
                <br />
            </div>
            <div className="ResponsiveContainer mt-5"></div>

            <div className="ResponsiveContainer">
                <section className="InputsSection">
                    <span>
                        <GenericInput
                            register={register}
                            name="firstName"
                            placeholder="Primer nombre"
                            maxLength={50}
                            tooltip="Primer nombre"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />

                        {/* <InputText
                            id="BuroName"
                            className="TextInput"
                            {...register("firstName", {
                                required: true,
                            })}
                            defaultValue={defaultVals.firstName}
                            placeholder="*Primer nombre"
                            autoComplete="given-name"
                        /> */}
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="secondName"
                            placeholder="Segundo nombre"
                            maxLength={50}
                            tooltip="Segundo nombre"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={false}
                        />
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="paternal"
                            placeholder="Apellido paterno"
                            maxLength={50}
                            tooltip="Apellido paterno"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="maternal"
                            placeholder="Apellido materno"
                            maxLength={50}
                            tooltip="Apellido materno"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />

                    </span>
                </section>
                <section className="InputsSection">
                    <Controller
                        name="birthday"
                        control={control}
                        render={({ field }) => <Calendar
                            inputId="BuroFechaNacimiento"
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            dateFormat="dd/mm/yy"
                            placeholder="Fecha de nacimiento"
                            showIcon
                            className=" rounded-lg w-[300px] Input"
                            maxDate={new Date()}
                            required={true}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                height: '49px',
                                // width: '300px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                },
                            }}
                            panelStyle={{
                                borderRadius: '17px'
                            }}
                        />}
                    />


                    {/* <Controller
                        name="birthday"
                        control={control}
                        render={({ field }) => <CustomDateInput {...field} />}
                    /> */}

                    {typePerson === 3 && (
                        <span>
                            <GenericInput
                                register={register}
                                name="rfc"
                                placeholder="RFC con homoclave"
                                maxLength={13}
                                tooltip="RFC con homoclave"
                                errors={errors}
                                setValue={setValue}
                                className="TextInput"
                                required={true}
                            />
                        </span>
                    )}

                    <span>
                        <GenericInput
                            register={register}
                            name="email"
                            placeholder="Correo electrónico"
                            maxLength={50}
                            tooltip="Correo electrónico"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                            pattern={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                        /*   validate={(value) => {
                              const email2Value = watch("email2");
                              if (!value || !email2Value) return true;
                              const isValid = value === email2Value;
                              return isValid ? true : "Los correos electrónicos no coinciden";
                          }} */
                        />
                    </span>

                    <span>
                        <GenericInput
                            register={register}
                            name="email2"
                            placeholder="Confirmar correo electrónico"
                            maxLength={50}
                            tooltip="Confirmar correo electrónico"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                            pattern={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                            validate={(value) => {
                                const emailValue = watch("email");
                                if (!value || !emailValue) return true;
                                const isValid = value === emailValue;
                                return isValid ? true : "Los correos electrónicos no coinciden";
                            }}
                        />
                    </span>


                </section>
            </div>
        </div>
    )
}
